// Accept only local SPA destinations, never a caller-provided external URL.
export const safeLoginReturnPath = (value) => {
  if (typeof value !== 'string' || value.length > 2048 || !value.startsWith('/') || value.startsWith('//')) return null;
  try {
    let decoded = value;
    for (let i = 0; i < 4; i += 1) {
      if (/^[\/]{2}|[\\\u0000-\u001f\u007f]/.test(decoded)) return null;
      const next = decodeURIComponent(decoded);
      if (next === decoded) break;
      decoded = next;
    }
    const url = new URL(value, window.location.origin);
    const decodedUrl = new URL(decoded, window.location.origin);
    for (const candidate of [url, decodedUrl]) {
      if (candidate.origin !== window.location.origin || candidate.pathname.startsWith('//') ||
          /^\/(login|register|reset-password|api)(\/|$)/i.test(candidate.pathname)) return null;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch { return null; }
};